import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ME_QUERY_KEY } from "@/auth/AuthContext";
import { mfaService } from "@/services/mfaService";

/** Generates a pending TOTP secret (does not touch /me). */
export function useMfaSetup() {
  return useMutation({ mutationFn: () => mfaService.setup() });
}

/** Activates MFA, then refetches /me so the gate/status update. */
export function useMfaConfirm() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (code: string) => mfaService.confirm(code),
    onSuccess: () => qc.invalidateQueries({ queryKey: ME_QUERY_KEY }),
  });
}

/** Disables MFA, then refetches /me. */
export function useMfaDisable() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (code: string) => mfaService.disable(code),
    onSuccess: () => qc.invalidateQueries({ queryKey: ME_QUERY_KEY }),
  });
}

/** Login 2nd factor: emits the session, then refetches /me. */
export function useMfaVerify() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (code: string) => mfaService.verify(code),
    onSuccess: () => qc.invalidateQueries({ queryKey: ME_QUERY_KEY }),
  });
}
